

var trackcmp_email = '';


// call the rest of the site tracking snippet here.
// Your "vanilla" site tracking snippet is found in ActiveCampaign settings --> tracking

var trackcmp = document.createElement("script");
trackcmp.async = true;
trackcmp.type = 'text/javascript';

// this will be different than your snippet
// see the actid query parameter in the string on the following line
trackcmp.src = '//trackcmp.net/visit?actid=66075252&e='+encodeURIComponent(trackcmp_email)+'&r='+encodeURIComponent(document.referrer)+'&u='+encodeURIComponent(window.location.href);


// this builds the site tracking snippet 
// and appends it to the <head> tag
var trackcmp_s = document.getElementsByTagName("script");
if (trackcmp_s.length) {
  trackcmp_s[0].parentNode.appendChild(trackcmp);
} else {
  var trackcmp_h = document.getElementsByTagName("head");
  trackcmp_h.length && trackcmp_h[0].appendChild(trackcmp);
}